<ng-container *ngIf="tipoPratica == null">
  <tipo-pratica-widget
    [tipoPratica]="tipoPratica"
    [tipoPraticaSugg]="getMatter()"
    (tipoPraticaChange)="setTipoPratica($event)"
  >
  </tipo-pratica-widget>
</ng-container>
<ng-container *ngIf="tipoPratica != null">
  <dati-gen-pratica-form
    [pratica]="pratica"
    [tipoPratica]="tipoPratica"
    (datiGeneraliChange)="updateDatiGenerali($event)"
    [resetForm]="resetForm"
    (valid)="changeValidity($event)"
  ></dati-gen-pratica-form>
  <classificazioni [classificazioni]="classificazioni"
  [hasPrincipale]="hasPrincipale"
  (classificazioneEmitter)="addClassificazione($event)"
  (classificazioneRemover)="removeClassificazione($event)"></classificazioni>

  <div class="row wizard-buttons">
    <p class="col-sm-3 col-xs-6">
      <!-- <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button> -->
    </p>
    <p
      class="col-sm-3 col-xs-6 col-sm-offset-6">
      <button type='button' class='btn btn-primary btn-block' [disabled]="checkDisabledBtn()" (click)="salva()">
        Prosegui
      </button>
    </p>

  </div>
</ng-container>

